import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';

/**
 * DropDownMenu Component.
 * For smaller devices (700 pixels and less)
 * 
 * It holds the link menu used in the NavBar
 * 
 * @param {*} props  The properties passed from its parent component (NavBar)
 */
function DropDownMenu(props) {
   let outerWrapperClasses = 'ddm-outer-wrapper';

   // If the MenuToggleButton is clicked it adds the "ddm-open" className in order to
   // open the menu
   if(props.show) {
      outerWrapperClasses += ' ddm-open';
   }
   return (
      <div className={outerWrapperClasses}>
         <div className="ddm-inner-wrapper">
            <ul className="ddm-list">
               <li className="ddm-item">
                  <Link className="ddm-link" to="/" onClick={props.clickHandler}>Home</Link>
               </li>
               <li className="ddm-item">
                  <Link className="ddm-link" to="/products" onClick={props.clickHandler}>Products</Link>
               </li>
               <li className="ddm-item">
                  <Link className="ddm-link" to="/about-us" onClick={props.clickHandler}>About Us</Link>
               </li>
               <li className="ddm-item">
                  <Link className="ddm-link" to="/whats-new" onClick={props.clickHandler}>What's New</Link>
               </li>
               <li className="ddm-item">
                  <Link className="ddm-link" to="/contact" onClick={props.clickHandler}>Contact</Link>
               </li>
               <li className="ddm-item">
                  <Link className="ddm-link" to="/cart" onClick={props.clickHandler}><FaShoppingCart /></Link>
                  {props.cartStorage.length > 0 ? <p id="number-cart" className="number-cart">{props.cartStorage.length}</p> : null}
               </li>
            </ul>
         </div>
      </div>
   )
}

export default DropDownMenu;